import React from "react";
import "./sponsors.css";

export default function Sponsors2022() {
	return (
		<div className="sponsors-2022">
			<h3>Our Sponsors</h3>
			<div class="carousel-2022">
				<img
					alt=""
					src="https://makaroon.bg/image/data/191214_makaroon%20logo%20-4.png"
				/>

				<img alt="" src="https://riodrinks.com/html/img/logo.png" />

				<img
					alt=""
					src="http://mdss.bg/wp-content/uploads/2012/03/malinova-dolina-sport-spa1.png"
				/>

				<img
					alt=""
					src="https://isic.bg/public/resources/uploads/discounts/58/2961aac991f2277e3460a204e3314855.png"
				/>

				<img
					alt=""
					src="https://biobenjamin.com/wp-content/uploads/2018/02/benjamissimo-logo.png"
				/>

				<img
					alt=""
					src="https://bonjourpizza.com/assets/img/logo.png"
				/>

				<img
					alt=""
					src="https://logos-world.net/wp-content/uploads/2020/03/Danone-logo.png"
				/>

				<img
					alt=""
					src="https://team-vision.bg/wp-content/uploads/2019/08/devin_logo-1.png"
				/>

				<img
					alt=""
					src="https://www.catalystglobal.com/wp-content/uploads/2018/10/CatalystBulgaria.png"
				/>

				<img
					alt=""
					src="https://franchiseportal.gr/wp-content/uploads/2021/08/franklin-logo-franchise.png"
				/>

				<img
					alt=""
					src="https://scontent-sof1-1.xx.fbcdn.net/v/t1.18169-9/14440648_196304270779585_786607223696459014_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=lO3N-bDugxEAX-_o6fm&_nc_ht=scontent-sof1-1.xx&oh=00_AT9VfcMdt9yvo9n0HQbIgoj3-fuWYRW-73AvQNtuNBDzJQ&oe=62617874"
				/>

				<img
					alt=""
					src="https://static.takeaway.com/images/restaurants/bg/0O317O11/logo_465x320.png"
				/>

				<img
					alt=""
					src="http://www.medovina.bg/bg/wp-content/uploads/2016/07/medovina-logo-red-1.png"
				/>

				<img
					alt=""
					src="https://scontent-sof1-1.xx.fbcdn.net/v/t1.6435-9/49899362_2602666663084117_5047503153180704768_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=Ch794HnbLl4AX-AHL8q&_nc_ht=scontent-sof1-1.xx&oh=00_AT_a-FXtw7TZWzgV06mDKqHGp6zHuFXGio40I6f1JnJvrA&oe=62614302"
				/>

				<img
					alt=""
					src="https://therecursive.com/wp-content/uploads/2021/11/officernd.jpg"
				/>

				<img
					alt=""
					src="https://yt3.ggpht.com/F-v9dAspnP9dH-HnAbi99IRpoCMdoJ45Ty4KJSBWWCwje2d4CDXivcdSbsjnUaRBYoj7nLmLPQ=s900-c-k-c0x00ffffff-no-rj"
				/>

				<img
					alt=""
					src="https://scontent-sof1-1.xx.fbcdn.net/v/t1.18169-9/10450166_596657197121095_8025605023210254560_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=2jmF7q1wbDoAX-FYH5m&tn=eUAW976t8HTSmE2K&_nc_ht=scontent-sof1-1.xx&oh=00_AT-Hm9ev8Bwx5nqMAVEoS_HnjgytZStTWUrvopt1l-PkHw&oe=625EC980"
				/>

				<img
					alt=""
					src="https://logos-world.net/wp-content/uploads/2020/11/Red-Bull-Logo.png"
					id="6"
				/>

				<img
					alt=""
					src="https://scontent-sof1-1.xx.fbcdn.net/v/t39.30808-6/240385429_262510029026343_5571694145785351996_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=hfu0gT9gm5YAX-9YQnr&_nc_oc=AQkpsmoiPC_ecokY2XZhLSDYmf3fiyji0zWB9PJpwbNGnCC6sdXcUJpw1oM6Sw4Pn-w&_nc_ht=scontent-sof1-1.xx&oh=00_AT_esx_mH-_OkRXDZxIPhvwQjBiPaqx_QWPj55mEmZc0dA&oe=623F1FE6"
					id="7"
				/>

				<img
					alt=""
					src="https://scontent-sof1-1.xx.fbcdn.net/v/t1.6435-9/69174846_1400418713439505_8788545321559916544_n.png?_nc_cat=103&ccb=1-5&_nc_sid=09cbfe&_nc_ohc=phZNyMOJlF4AX89wy_T&_nc_ht=scontent-sof1-1.xx&oh=00_AT8eggCLAE5RN1eDoYB23E0BKWIdiQeXPTSuZHo1YdgbGA&oe=626025D5"
				/>

				<img
					alt=""
					src="https://vidas.bg/wp-content/uploads/2021/08/Asset-3@2x.png"
				/>
			</div>
		</div>
	);
}
